import { Stack } from '@mui/material';
import { headerActionSlotRef } from '../../services/shellBridge/headerActionSlot';

/** DOM mount point for remote apps that call shell.requestHeaderSlot(). */
export function HeaderActionSlot() {
  return (
    <Stack
      direction="row"
      alignItems="center"
      ref={(el: HTMLDivElement | null) => {
        headerActionSlotRef.current = el;
      }}
      sx={{
        position: 'relative',
        flexShrink: 0,
      }}
    />
  );
}
